import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient } from '@/hooks'
import { getUseManualHoursReportsKey } from '@/hooks'

import { unwrapErrorResponse, unwrapResponse } from '@/utils'
import {
  APIErrorResponse,
  ManualHoursReport,
  PostManualHoursReport,
} from '@/types'

export const usePostManualHoursReport = (): UseMutationResult<
  ManualHoursReport,
  APIErrorResponse,
  PostManualHoursReport
> => {
  const client = useApiClient()
  const queryClient = useQueryClient()
  const listKey = getUseManualHoursReportsKey(false)

  return useMutation(
    (params) =>
      client
        .post(`/hours_reporting/manual-hours/`, params)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(listKey)
      },
    }
  )
}
